document.addEventListener('DOMContentLoaded', () => {

  // =======================================================
  // 1. ANIMATED SEARCH PLACEHOLDER
  // =======================================================
  const searchInput = document.querySelector('.mobile-search-pill input[type="search"]') || 
                      document.querySelector('.mobile-search-pill input.search__input');
  
  if (searchInput) {
    const phrases = [
      "Search 'Mangoes'...", 
      "Search 'Gift Baskets'...", 
      "Search 'Thai Fruits'...",
      "Search 'Berries'...",
      "Search 'Exotic Fruits'..."
    ];
    
    let phraseIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let isFocused = false;

    // Pause animation when user clicks to type
    searchInput.addEventListener('focus', () => {
      isFocused = true;
      searchInput.setAttribute('placeholder', 'Search for products...');
    });
    
    searchInput.addEventListener('blur', () => {
      isFocused = false;
    });

    function typeEffect() {
      // Don't animate if user is typing or clicked into the box
      if (isFocused || searchInput.value.length > 0) {
        setTimeout(typeEffect, 1000);
        return;
      }

      const currentPhrase = phrases[phraseIndex];
      
      if (isDeleting) {
        searchInput.setAttribute('placeholder', currentPhrase.substring(0, charIndex - 1));
        charIndex--;
      } else {
        searchInput.setAttribute('placeholder', currentPhrase.substring(0, charIndex + 1));
        charIndex++;
      }

      let typingSpeed = isDeleting ? 40 : 80;

      if (!isDeleting && charIndex === currentPhrase.length) {
        isDeleting = true;
        typingSpeed = 2000; 
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        typingSpeed = 500; 
      }

      setTimeout(typeEffect, typingSpeed);
    }
    
    setTimeout(typeEffect, 1000);
  }

  // =======================================================
  // 2. LOCATION MODAL LOGIC
  // =======================================================
  const modal = document.getElementById('LocationSelectorModal');
  const triggers = document.querySelectorAll('.location-trigger');
  const closeBtn = document.getElementById('LocationModalClose');
  const saveBtn = document.getElementById('LocationModalSave');
  const detectBtn = document.getElementById('LocationModalDetect');
  const pinInput = document.getElementById('LocationModalPin');
  const errorMsg = document.getElementById('LocationModalError');
  const valueDisplays = document.querySelectorAll('.location-trigger__value');

  const STORAGE_KEY = 'kriparam_delivery_pin';

  // Load saved PIN on refresh
  const savedPin = localStorage.getItem(STORAGE_KEY);
  if (savedPin) updateHeaderDisplay(savedPin);

  function updateHeaderDisplay(pin) {
    valueDisplays.forEach(el => el.textContent = pin);
  }

  function showError(msg) {
    if (!errorMsg) return;
    errorMsg.textContent = msg;
    errorMsg.style.display = 'block';
  }

  if (modal && triggers.length) {
    // Open Modal
    triggers.forEach(t => t.addEventListener('click', (e) => { 
      e.preventDefault(); 
      modal.showModal(); 
    }));

    // Close Modal
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        modal.close();
        if (errorMsg) errorMsg.style.display = 'none';
      });
    }

    // Save PIN manually
    if (saveBtn && pinInput) {
      saveBtn.addEventListener('click', () => {
        const pin = pinInput.value.trim();
        if (pin.length > 2) { // Accepts cities, landmarks, or pins
          localStorage.setItem(STORAGE_KEY, pin);
          updateHeaderDisplay(pin);
          modal.close();
          if (errorMsg) errorMsg.style.display = 'none';
        } else {
          showError('Please enter a valid location.');
        }
      });
    }

    // Auto-detect Location
    if (detectBtn && pinInput && saveBtn) {
      detectBtn.addEventListener('click', () => {
        if (!navigator.geolocation) return showError('Location not supported by your browser.');
        
        const originalText = detectBtn.innerHTML;
        detectBtn.innerHTML = '<span>Detecting...</span>';
        
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            try {
              const res = await fetch(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=en`);
              const data = await res.json();
              if (data.postcode || data.city) {
                const locationValue = data.postcode || data.city;
                pinInput.value = locationValue;
                saveBtn.click(); // Auto-save after detect
              } else {
                showError('Could not determine exact location. Please type it.');
              }
            } catch (err) {
              showError('Failed to fetch location.');
            } finally {
              detectBtn.innerHTML = originalText;
            }
          },
          () => {
            showError('Permission denied. Please type your location manually.');
            detectBtn.innerHTML = originalText;
          }
        );
      });
    }
  }
});